import * as React from 'react';
import styled from 'threads5/styles/styled';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';

const StyledHeading2 = styled('h2')(({ theme }) => {
  return {
    fontFamily: theme.typography.plaidSans,
    fontSize: '8.0rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '100%',
    letterSpacing: '-2px',
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
      fontSize: '4.0rem',
      lineHeight: '114%',
    },
  };
});

const Heading2 = React.forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithRef<'h2'> & { sx?: SxProps<ITheme> }
>(({ sx, ...props }, ref) => {
  return (
    <StyledHeading2 ref={ref} sx={sx} {...props}>
      Simple, scalable plans for businesses of all sizes
    </StyledHeading2>
  );
});
Heading2.displayName = 'Heading2';

export default Heading2;
